import React, { useState } from "react";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import "./FooterStyle.css";
import footerLogo from "../../assets/images/kaphy-insurance-agency.png";
import { useAuth } from "../../context/AuthContext";
import { useBusinessSettings } from "../../hooks/useBusinessSettings";
import DirectionsTooltip from "../common/DirectionsTooltip";

const scrollWithOffset = (el) => {
  const top = el.getBoundingClientRect().top + window.pageYOffset - 80;
  window.scrollTo({ top, behavior: "smooth" });
};

const Footer = () => {
  const [email, setEmail] = useState("");
  const { user } = useAuth();
  const { settings } = useBusinessSettings();
  const { address } = settings;

  if (user) return null;

  const handleSubscribe = (e) => {
    e.preventDefault();
    console.log("Subscribing email:", email);
    setEmail("");
  };

  return (
    <footer className="modern-footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-main">
            <div className="company-section">
              <div className="logo-section">
                <img
                  src={footerLogo}
                  alt="Kaphy Insurance Agency"
                  className="footer-logo"
                />
                {/* <h3 className="company-name">Kaphy Insurance Agency</h3> */}
              </div>
              <p className="company-description">
                Protecting your today and tomorrow with trusted insurance
                solutions. Serving customers near Karmel Mall Shopping Center,
                Cedar-Riverside, and throughout Minneapolis, St. Paul, and the
                Twin Cities. Licensed in Minnesota with A+ rating.
              </p>
              <div className="company-stats">
                <div className="stat-item">
                  <i className="fa-solid fa-shield"></i>
                  <span>A+ Rated</span>
                </div>
                <div className="stat-item">
                  <i className="fa-solid fa-location-dot"></i>
                  <span>Minnesota Licensed</span>
                </div>
                <div className="stat-item">
                  <i className="fa-regular fa-clock"></i>
                  <span>Years Experience</span>
                </div>
              </div>
            </div>

            <div className="links-section">
              <h4 className="footer-section-title">Services</h4>
              <div className="links-grid">
                <HashLink
                  smooth
                  scroll={scrollWithOffset}
                  to="/our-products#auto-insurance"
                  className="footer-link"
                >
                  Auto Insurance
                </HashLink>
                <HashLink
                  smooth
                  scroll={scrollWithOffset}
                  to="/our-products#home-insurance"
                  className="footer-link"
                >
                  Home Insurance
                </HashLink>
                <Link to="/renters-insurance" className="footer-link">
                  Renters Insurance
                </Link>
                <Link to="/life-insurance" className="footer-link">
                  Life Insurance
                </Link>
                <HashLink
                  smooth
                  scroll={scrollWithOffset}
                  to="/our-products#commercial-insurance"
                  className="footer-link"
                >
                  Commercial Insurance
                </HashLink>
                <Link to="/insurance-carriers" className="footer-link">
                  Insurance Carriers
                </Link>
                <Link
                  to="/auto-insurance-minneapolis-mn"
                  className="footer-link"
                >
                  Auto Insurance Minneapolis
                </Link>
                <Link
                  to="/minneapolis-insurance-agency"
                  className="footer-link"
                >
                  Minneapolis Insurance
                </Link>
                <Link
                  to="/karmel-mall-insurance-agency"
                  className="footer-link"
                >
                  Karmel Mall Insurance
                </Link>
                <Link
                  to="/somali-insurance-agent-minneapolis"
                  className="footer-link"
                >
                  Somali Insurance Agent
                </Link>
                <Link to="/get-quote-today" className="footer-link highlight">
                  Get Free Quote
                </Link>
              </div>
            </div>

            <div className="links-section">
              <h4 className="footer-section-title">Company</h4>
              <div className="links-grid">
                <Link to="/about-us" className="footer-link">
                  About Us
                </Link>
                <Link to="/contact-us" className="footer-link">
                  Contact
                </Link>
                <Link to="/appointments" className="footer-link highlight">
                  Book an Appointment
                </Link>
                <Link to="/location/our-locations" className="footer-link">
                  Locations
                </Link>
                <Link to="/office-open-hours" className="footer-link">
                  Office Hours
                </Link>
              </div>
            </div>

            <div className="links-section">
              <h4 className="footer-section-title">Insurance Guides</h4>
              <div className="links-grid">
                <Link to="/guides" className="footer-link">
                  All Guides
                </Link>
                <Link
                  to="/guides/renters-insurance-cost-minnesota"
                  className="footer-link"
                >
                  Renters Insurance Cost MN
                </Link>
                <Link
                  to="/guides/auto-insurance-minneapolis-mn-guide"
                  className="footer-link"
                >
                  Auto Insurance Minneapolis
                </Link>
                <Link
                  to="/guides/homeowners-insurance-minneapolis-guide"
                  className="footer-link"
                >
                  Homeowners Insurance MN
                </Link>
                <Link
                  to="/guides/commercial-insurance-small-business-minneapolis"
                  className="footer-link"
                >
                  Small Business Insurance
                </Link>
                <Link
                  to="/guides/independent-insurance-agents-vs-direct-companies"
                  className="footer-link"
                >
                  Independent Agents Guide
                </Link>
              </div>
            </div>

            <div className="contact-section">
              <h4 className="footer-section-title">Contact</h4>
              <div className="contact-info">
                <div className="contact-item">
                  <i className="fa-solid fa-phone"></i>
                  <a href="tel:6514440402">(651) 444-0402</a>
                </div>
                <div className="contact-item">
                  <i className="fa-solid fa-envelope"></i>
                  <a href="mailto:sales@kaphyinsurance.com">
                    Submit an inquiry
                  </a>
                </div>
                <div className="contact-item">
                  <i className="fa-solid fa-location-dot"></i>
                  <span>
                    {address.street}, {address.floorSuite}
                    <br />
                    {address.city}, {address.state} {address.zip}
                    <DirectionsTooltip />
                  </span>
                </div>
              </div>

              <div className="newsletter d-none">
                <h4 className="newsletter-title">Stay Updated</h4>
                <form onSubmit={handleSubscribe} className="newsletter-form">
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Your email address"
                    className="newsletter-input"
                    required
                  />
                  <button type="submit" className="newsletter-btn">
                    <i className="fa-solid fa-paper-plane"></i>
                  </button>
                </form>
              </div>
            </div>
          </div>

          <div className="footer-bottom">
            <div className="footer-bottom-content">
              <div className="copyright">
                <p>
                  &copy; {new Date().getFullYear()} Kaphy Insurance Agency. All
                  rights reserved.
                </p>
                <div className="legal-links">
                  <Link to="/privacy">Privacy</Link>
                  <Link to="/terms">Terms</Link>
                  <Link to="/accessibility">Accessibility</Link>
                  <button
                    type="button"
                    className="footer-cookie-settings-btn"
                    onClick={() => window.dispatchEvent(new CustomEvent("kaphyCookieSettingsOpen"))}
                    aria-label="Open cookie preferences"
                  >
                    Cookie Settings
                  </button>
                </div>
                <div className="crafted-by">
                  <a
                    href="https://cititekpro.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="crafted-link"
                  >
                    Crafted by CitiTekPro
                  </a>
                </div>
              </div>

              <div className="footer-right">
                <div className="social-links">
                  <a
                    href="https://www.facebook.com/kaphyinsuranceagency"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fa-brands fa-facebook"></i>
                  </a>
                  <a
                    href="https://www.youtube.com/@kaphyinsuranceagency"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fa-brands fa-youtube"></i>
                  </a>
                  <a
                    href="https://www.instagram.com/kaphyinsuranceagency/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fa-brands fa-instagram"></i>
                  </a>
                  <a
                    href="https://www.pinterest.com/kaphyinsuranceagency"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fa-brands fa-pinterest"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
